/**
 * Header logo symbol -> wordmark scroll crossfade, entirely self-contained
 * within the nav bar (sections/furlouve-header.liquid): on load the header
 * shows only the standalone heart symbol; as the page scrolls, it fades and
 * scales into the full wordmark in exactly the same centered spot. There is
 * only ever one logo element — this crossfades opacity/scale between two
 * layers stacked in the same box, it never moves, duplicates, or detaches
 * the logo from the header.
 *
 * Global (every page has a header, not just the homepage), so the trigger
 * is a fixed scroll distance from the top of the page rather than tied to
 * any particular section like the homepage hero.
 *
 * Every animated property is opacity or a GSAP transform (scale/y), which
 * compose into a single GPU-composited transform — never width, height,
 * top, or left — so this never forces layout mid-scroll, and neither layer
 * ever moves from the header's centered logo position.
 *
 * Safe by construction, not by extra fallback branching: the CSS resting
 * state (sections/furlouve-header.liquid) already shows the classic
 * wordmark-only logo with the symbol hidden. This script only overrides
 * that once motion is allowed and GSAP/ScrollTrigger are confirmed
 * available — if either is false, it does nothing and the classic logo
 * stands, so a slow/blocked script can never leave the logo permanently
 * showing the wrong layer. Scroll-linked, so touch scrolling drives it
 * exactly like mouse/trackpad scrolling — no separate touch handling
 * needed.
 */
import { motionEnabled } from '@theme/premium-motion';

const wordmark = document.querySelector('.flv-nav__logo-wordmark');
const symbol = document.querySelector('.flv-nav__logo-symbol');

if (wordmark && symbol && motionEnabled && typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
  gsap.set(symbol, { opacity: 1, scale: 1, y: 0 });
  gsap.set(wordmark, { opacity: 0, scale: 0.85, y: 6 });

  gsap.timeline({
    defaults: { ease: 'power2.inOut', force3D: true },
    scrollTrigger: {
      trigger: document.documentElement,
      start: 'top top',
      end: '+=560',
      scrub: 0.6,
    },
  })
    .to(symbol, { opacity: 0, scale: 0.85, y: -6, duration: 1 }, 0)
    .to(wordmark, { opacity: 1, scale: 1, y: 0, duration: 1 }, 0);
}
